import * as React from 'react';
import Styled, { css } from 'styled-components';

import { media, VALID_BUTTON_STYLE } from '../../lib/StyledComponents';

import { IButtonProps } from './common';

/* stylelint-disable declaration-colon-newline-after */
const buttonInlineStyles = css`
  ${({ theme: { button } }) => css`
    ${media.small`
      width: auto;
      min-width: ${button.baseButtonMinWidth};
      display: inline-block;
    `}

    > * {
      display: inline-block;
    }
  `};
`;
/* stylelint-enable declaration-colon-newline-after */

const DEFAULT_BUTTON_STYLE: VALID_BUTTON_STYLE = 'primary';

export const BaseButtonStyles = css<IButtonProps>`
  width: 100%;
  /* stylelint-disable declaration-colon-newline-after */
  padding: ${({ theme: { button }, size, buttonStyle }) =>
    size === 'tiny' ? button.tinyPadding : button[buttonStyle || DEFAULT_BUTTON_STYLE].padding
  };
  /* stylelint-enable */
  box-shadow: ${({theme: { button }, buttonStyle }) => button[buttonStyle || DEFAULT_BUTTON_STYLE].boxShadow};
  display: block;
  position: relative;
  border-radius: ${({ theme: { button } }) => button.borderRadius};
  border: 0;
  line-height: 1.2;
  transition: color 100ms ease-out, background 100ms ease-out;
  text-align: center;
  text-transform: ${({ theme: { button } }) => button.textTransform};
  font-size: ${({ theme: { button }, size }) => size === 'tiny' ? button.tinySize : button.fontSize};
  font-weight: ${({ theme: { button } }) => button.fontWeight};
  letter-spacing: ${({ theme: { button }}) => button.letterSpacing};
  cursor: ${({ disabled }) => disabled ? 'default' : 'pointer'};

  ${({theme: { button }}) => button.focusBoxShadow && css`
    border-width: ${button.borderWidth} !important; // overrides ButtonStyles PrimaryActive. will be rmved theme2.

    &:focus {
      box-shadow: ${button.focusBoxShadow};
      border-width: ${button.borderWidth} !important; // overrides ButtonStyles PrimaryActive. will be rmved theme2.
      outline: none;
    }
  `};

  span,
  svg {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  ${props => props.inline ? buttonInlineStyles : ''}
`;

export const BaseButtonStyled = Styled.button<IButtonProps>`
  ${BaseButtonStyles}
`;

BaseButtonStyled.defaultProps = {
  disabled: false,
  inline: false,
  size: 'normal',
  buttonStyle: DEFAULT_BUTTON_STYLE,
};

export class BaseButton extends React.Component<IButtonProps> {
  public render () {
    return <BaseButtonStyled {...this.props} onClick={this.onClick} />;
  }

  private readonly onClick: React.MouseEventHandler<HTMLButtonElement> = e => {
    if (this.props.disabled) {
      e.preventDefault();

      return;
    }

    if (!this.props.onClick) { return; }

    this.props.onClick(e);
  }
}

export default BaseButton;
